function Footer() {
  return (
    <footer>
      <p>
        Designed and Created by {' '}
        <a href="https://www.linkedin.com/in/gichuljaun/" target="_blank" rel="noreferrer">
          Gichul Jaun
        </a>
      </p>
    </footer>
  );
}

export default Footer;
